import { Component, OnDestroy, AfterContentInit } from '@angular/core';
import {CommonModalBase} from "../common/commonModalBase.abstract";
import {ModalAsmExpireInterface} from "./modal-asm-expire.interface";
import {CommonModalService} from "../../common-modal/common-modal.service";
import {CommonModalTemplatesEnum} from "../all-modals-config";
import { timer, Subscription } from "rxjs";
import {AsmService} from "../../../services/asm.service";
declare const window: any;

@Component({
  selector: 'v-modal-asm-expire',
  templateUrl: './modal-asm-expire.component.html'
})
export class ModalAsmExpireComponent extends CommonModalBase<ModalAsmExpireInterface> {
  private countDown: Subscription;
  private tick = 1000;
  public counter: number;
  public agentTimer: number;
  public logoutDisabled = false;
  public beforeMode = true;

  constructor(
    commonModalService: CommonModalService,
    private asmService: AsmService
  ) {
    super(
      commonModalService,
      CommonModalTemplatesEnum.ASM_EXPIRE,
    );
  }

  ngAfterContentInit() {
    this.counter = this.modalData.counter;
    this.agentTimer = this.modalData.agentTimer;
    this.countDown = timer(0, this.tick).subscribe(() => {
      if(this.counter > 0) {
        this.counter--;
      } else {
        this.asmService.logoutAsm().subscribe(() => {});
        this.beforeMode = false;
        this.countDown.unsubscribe();
      }
    });
  }

  ngOnDestroy() {
    this.countDown.unsubscribe();
  }

  logoutAsmUser() {
    this.countDown.unsubscribe();
    this.logoutDisabled = true;
    window.finishASMagentSession();
  }

  resetCounter() {
    window.ASM_TIMER.redirectMode
    && (() => document.getElementById('bpr_asm-ses-btn') ?  document.forms['_asmPersonifyForm'].submit() : this.login())();

    this.modalData.resetSession();
    window.stopAsmLogoutTimer();
    window.startSession(this.agentTimer);
    window.resetSession();
  }

  login() {
    window.location.href = '/?asm=true';
  }
}
